import pathOr from 'ramda/src/pathOr'
import F from 'ramda/src/F'

import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, fieldDescPath }) => pathOr(
	F,
	[moduleId, ...fieldDescPath, 'fieldsResetCondition'],
	moduleDescriptions,
)
